/**
 * @generated SignedSource<<4b70d1383a9b133abc6abb94ffe602f0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PromotionActivateInput = {
  id: string;
};
export type PromotionActionsMutationButtonStack_promotionActivateMutation$variables = {
  input: PromotionActivateInput;
};
export type PromotionActionsMutationButtonStack_promotionActivateMutation$data = {
  readonly promotionActivate: {
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"PromotionActionsMutationButtonStack_promotion" | "PromotionStatusLabel_promotion">;
  };
};
export type PromotionActionsMutationButtonStack_promotionActivateMutation = {
  response: PromotionActionsMutationButtonStack_promotionActivateMutation$data;
  variables: PromotionActionsMutationButtonStack_promotionActivateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PromotionActionsMutationButtonStack_promotionActivateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Promotion",
        "kind": "LinkedField",
        "name": "promotionActivate",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PromotionStatusLabel_promotion"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PromotionActionsMutationButtonStack_promotion"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PromotionActionsMutationButtonStack_promotionActivateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Promotion",
        "kind": "LinkedField",
        "name": "promotionActivate",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "actions",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "priority",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "startAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "endAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isRepeat",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "repeatType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "repeatValue",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "query",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3be8482577f52007c972a55b9fec58c3",
    "id": null,
    "metadata": {},
    "name": "PromotionActionsMutationButtonStack_promotionActivateMutation",
    "operationKind": "mutation",
    "text": "mutation PromotionActionsMutationButtonStack_promotionActivateMutation(\n  $input: PromotionActivateInput!\n) {\n  promotionActivate(input: $input) {\n    id\n    ...PromotionStatusLabel_promotion\n    ...PromotionActionsMutationButtonStack_promotion\n  }\n}\n\nfragment PromotionActionsMutationButtonStack_promotion on Promotion {\n  id\n  actions\n  ...PromotionUpdateDialog_promotion\n}\n\nfragment PromotionStatusLabel_promotion on Promotion {\n  status\n}\n\nfragment PromotionUpdateDialog_promotion on Promotion {\n  id\n  title\n  priority\n  startAt\n  endAt\n  isRepeat\n  repeatType\n  repeatValue\n  query\n}\n"
  }
};
})();

(node as any).hash = "403dfa713525720f94296712f4f54769";

export default node;
